import styled from 'styled-components';

import { colors } from 'global/colors';

export const NumberOfTests = styled.div`
  display: flex;
  width: 60%;
  height: 100%;
  justify-content: center;
  align-items: center;
  float: left;
  font-size: 22px;
  font-family: 'Open Sans', sans-serif;
`;

export const Increment = styled.div`
  display: flex;
  border-left: 1px solid ${colors.fsDarkBlue};
  justify-content: center;
  align-items: center;
  float: right;
  height: 100%;
  width: 20%;
  font-size: 25px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: 'Open Sans', sans-serif;

  &:hover {
    background-color: ${colors.fsDarkBlue};
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    color: white;
  }
`;

export const Decrement = styled.div`
  display: flex;
  border-right: 1px solid ${colors.fsDarkBlue};
  align-items: center;
  justify-content: center;
  float: left;
  height: 100%;
  width: 20%;
  font-size: 25px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:hover {
    background-color: ${colors.fsDarkBlue};
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    color: white;
  }
`;

export const EditablePlan = styled.div`
  margin-top: 4px;
  margin-left: 12px;
  margin-right: 12px;
  height: 50px;
  border: 0.5px solid ${colors.fsDarkBlue};
  border-radius: 6px;
`;

export const PlanContainer = styled.div`
  display: inline-block;
  width: 202px;
  border: 1px solid ${colors.fsDarkBlue};
  border-radius: 6px;
  -webkit-transition: all 0.25s;
  -moz-transition: all 0.25s;
  -ms-transition: all 0.25s;
  -o-transition: all 0.25s;
  transition: all 0.25s;

  &:hover {
    cursor: pointer;
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -ms-transform: scale(1.05);
    -o-transform: scale(1.05);
    transform: scale(1.05);
  }
`;

export const CurrencyContainer = styled.div.attrs({ className: 'dropdown' })`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
  padding: 0px;
`;

export const PlanType = styled.div`
  width: 200px;
  border-radius: 5px 5px 0px 0px;
  background-color: ${colors.fsDarkBlue};
  height: 50px;

  & p {
    font-family: 'Open Sans', sans-serif;
    font-size: 22px;
    text-transform: uppercase;
    color: white;
    text-align: center;
    padding-top: 10px;
  }
`;

export const PlanDiv = styled.div`
  background-color: white;
  border-radius: 0px 0px 6px 6px;
  font-family: 'Open Sans', sans-serif;
  font-style: condensed;
  font-size: 30px;
  color: black;
  text-align: center;
  position: relative;
`;

export const PlanCurrency = styled.p`
  display: inline;
  font-size: 12px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
`;

export const PlanHeader = styled.div`
  height: ${(props) => (props.discounted ? `165px` : `120px`)};

  & span {
    font-size: 22px;
    font-family: 'Open Sans', sans-serif;
  }
`;

export const CurrencyFlag = styled.img`
  height: 15px;
  width: 18px;
  margin-left: 10px;
  margin-bottom: 3px;
`;

export const CurrencyDropdownButton = styled.button.attrs({ className: 'btn btn-secondary dropdown-toggle' })`
  background-color: #fff !important;
  color: black !important;
  border: 1px solid #fff !important;

  &:hover {
    background-color: ${colors.fsDarkBlue} !important;
    border: 1px solid ${colors.fsDarkBlue} !important;
    color: white !important;
  }

  &:active {
    background-color: #fff !important;
    color: black !important;
    border: 1px solid #fff !important;
  }

  &::after {
    vertical-align: 0px !important;
  }

  &:focus {
    box-shadow: none !important;
  }

  &:not(:disabled):not(.disabled):active {
    background-color: ${colors.fsDarkBlue} !important;
    border: 1px solid ${colors.fsDarkBlue} !important;
  }

  &:not(:disabled):not(.disabled):active:focus {
    box-shadow: none !important;
  }
`;

export const DropdownMenuBlock = styled.div.attrs({ className: 'dropdown-menu' })`
  min-width: min-content !important;
  top: -7px !important;
  left: -10px !important;
  padding: 0px !important;
`;

export const DropdownItem = styled.a.attrs({ className: 'dropdown-item' })`
  &:active {
    background-color: #285c87 !important;
  }

  &:hover {
    background-color: lightgrey !important;
  }
`;

export const DiscountedPrice = styled.div`
  text-decoration: line-through;
  color: #285c87;
  font-size: 18px;
`;

export const PurchaseTab = styled.div``;
export const OffersContainer = styled.div.attrs({ className: 'mb-3' })``;
export const Offer = styled.span``;
